// kwikpass-auto-open.js (patched — will open drawer if UI still shows sign-in even when server says logged-in)
// Auto-opener: opens KwikPass login drawer 5s after page load (safe, loop-guarded).
// Place AFTER Kwik embed scripts. Enable debug with window.KWIK_DEBUG = true before reload.

(function(){
  const DELAY_MS = 5000;
  const LOGIN_LOCK_KEY = 'kwik_auto_open_lock';
  const LOGIN_LOCK_MS = 60 * 1000; // avoid re-opening for 60s
  const DEBUG = !!window.KWIK_DEBUG;

  function dbg(...args){ if (DEBUG) console.log.apply(console, ['%c[KwikAutoOpen]','background:#124;color:#9ff;padding:2px 6px;border-radius:3px;',...args]); }

  function nowMs(){ return Date.now(); }
  function setLock(){
    try { sessionStorage.setItem(LOGIN_LOCK_KEY, String(nowMs())); dbg('lock set'); } catch(e){ dbg('lock set failed', e); }
  }
  function isLockActive(){
    try {
      const v = sessionStorage.getItem(LOGIN_LOCK_KEY);
      if (!v) return false;
      const t = parseInt(v,10);
      if (isNaN(t)) return false;
      return (nowMs() - t) < LOGIN_LOCK_MS;
    } catch(e){ return false; }
  }
  function clearLock(){ try { sessionStorage.removeItem(LOGIN_LOCK_KEY); dbg('lock cleared'); } catch(e){} }

  async function serverSaysLoggedIn(){
    try {
      const res = await fetch('/account?__kwik_check=' + Date.now(), { method:'GET', credentials:'same-origin', cache:'no-store' });
      if (!res.ok) { dbg('/account fetch not ok', res.status); return false; }
      const text = (await res.text()).toLowerCase();
      const logged = /log out|sign out|\/account\/logout|order history|account overview/.test(text);
      dbg('serverSaysLoggedIn ->', logged);
      return logged;
    } catch(e){ dbg('serverSaysLoggedIn error', e); return false; }
  }

  // Heuristic: does the current page DOM show "signed-out" UI?
  function pageShowsSignedOut(){
    try {
      // common sign-in prompts/links used by themes
      const selectors = [
        'a[href="/account/login"]',
        'a[href*="/account"] .sign-in, a[href*="/account"] .signin',
        '.customer-login', '.checkout__customer_login',
        '.account-button.header-actions__action', // horizon/hybrid: may be present when signed-in, but we'll check visibility
        '.header__icon--account',
        '.nav-link--account',
        '.header__link--login',
        '.sign-in'
      ];
      // If there's an explicit visible "Sign in" link, that's a strong indicator
      for (const sel of selectors) {
        const el = document.querySelector(sel);
        if (!el) continue;
        // check visibility
        const style = window.getComputedStyle(el);
        const visible = style && style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
        if (visible) {
          dbg('pageShowsSignedOut -> matched selector', sel);
          return true;
        }
      }

      // Also detect if the header shows a "Sign in" text node (some themes render text)
      const signText = Array.from(document.querySelectorAll('a,button,div,span')).find(n => {
        if (!n || !n.innerText) return false;
        const t = n.innerText.trim().toLowerCase();
        return t === 'sign in' || t === 'signin' || t === 'log in' || t === 'login';
      });
      if (signText) {
        dbg('pageShowsSignedOut -> found visible sign-in text');
        return true;
      }

      dbg('pageShowsSignedOut -> no obvious sign-in UI found');
      return false;
    } catch(e){
      dbg('pageShowsSignedOut error', e);
      return false;
    }
  }

  function openKwikDrawer(){
    try {
      if (isLockActive()) { dbg('openKwikDrawer suppressed — lock active'); return false; }
      setLock();
      if (typeof window.handleKpAndShopifyLogin === 'function') {
        dbg('opening Kwik via handleKpAndShopifyLogin()');
        window.handleKpAndShopifyLogin();
        return true;
      }
      if (window.KwikPassDefensive && typeof window.KwikPassDefensive.openKwikDrawer === 'function') {
        dbg('opening Kwik via KwikPassDefensive.openKwikDrawer()');
        window.KwikPassDefensive.openKwikDrawer();
        return true;
      }
      dbg('no Kwik opener found on window');
      clearLock();
      return false;
    } catch(e){ dbg('openKwikDrawer error', e); clearLock(); return false; }
  }

  async function maybeOpen(){
    try {
      const path = location.pathname || '';

      // prefer not to auto-open on actual checkout pages (but you can change this)
      if (path.startsWith('/checkouts')) {
        dbg('on checkout path — skipping auto-open (to avoid fighting checkout)'); 
        return;
      }

      // wait a short time to let theme render header
      await new Promise(r => setTimeout(r, 200)); 

      // If page DOM clearly shows signed-out UI, open unconditionally (unless locked)
      const domShowsSignedOut = pageShowsSignedOut();
      if (domShowsSignedOut) {
        dbg('DOM shows signed-out -> opening Kwik drawer (even if server says logged-in)');
        openKwikDrawer();
        return;
      }

      // If page doesn't obviously show signed-out UI, fall back to server check
      const logged = await serverSaysLoggedIn();
      if (!logged) {
        dbg('server indicates not logged-in -> opening Kwik drawer');
        openKwikDrawer();
        return;
      }

      // Edge case: server says logged-in but page still has hidden sign-in artifacts (some themes)
      // Re-check DOM after a small delay and open if it still looks signed-out.
      await new Promise(r => setTimeout(r, 300));
      if (pageShowsSignedOut()) {
        dbg('server says logged-in but DOM still indicates signed-out -> opening Kwik drawer to reconcile');
        openKwikDrawer();
        return;
      }

      dbg('no open needed — server and DOM indicate logged-in or no prompts.');
    } catch(e){
      dbg('maybeOpen error', e);
    }
  }

  // API for manual control
  window.KwikAuto = window.KwikAuto || {};
  window.KwikAuto.openNow = async function(){
    dbg('KwikAuto.openNow called');
    clearLock();
    return openKwikDrawer();
  };
  window.KwikAuto.clearLock = clearLock;
  window.KwikAuto.isLockActive = isLockActive;

  // kick it off after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ()=> setTimeout(maybeOpen, DELAY_MS));
  } else {
    setTimeout(maybeOpen, DELAY_MS);
  }

  dbg('kwikpass-auto-open (patched) installed (enable logging with window.KWIK_DEBUG = true before reload).');
})();